  export default function (to, from, next) {
    const isAuthenticated = localStorage.getItem('token')
  
    if (isAuthenticated) {
      next()
    } else {
      next('/')
    }
  }
  